export enum SelfServiceRoutes {
  "ForgotPassword" = "forgot-password",
  "ResetPassword" = "reset-password",
  "LegalSubmission" = "legal/submission",
}
